import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';

import { STEP_NAMES } from '../../constants';

import styles from '@/components/TariffCalculatorNew/TariffCalculator.module.scss';

interface StepProgressProps {
	step: number;
}

export function StepProgress({ step }: StepProgressProps) {
	const { t } = useTranslation(TranslationNamespace.Calculator);
	const total = STEP_NAMES.length;
	const percent = ((step + 1) / total) * 100;

	return (
		<div className={styles.progressWrap}>
			<div className={styles.progressHead}>
				<strong>{t(STEP_NAMES[step])}</strong>
				<span>{t('progress.step', { current: step + 1, total })}</span>
			</div>
			<div className={styles.progressTrack} aria-hidden="true">
				<div className={styles.progressBar} style={{ width: `${percent}%` }} />
			</div>
		</div>
	);
}
